import React from 'react';
import logoImg from '../assets/logo.png';

export default function Logo({ size = 40 }) {
  return (
    <img
      src={logoImg}
      alt="PERM Systems"
      width={size}
      height={size}
      style={{ display: 'block', objectFit: 'contain' }}
    />
  );
}